import {DataChange} from "@colyseus/schema";
import {KitchenScene} from "./scene";
import GameObject = Phaser.GameObjects.GameObject;
import Group = Phaser.GameObjects.Group;
import {GameSchema} from "../model/game_element_schema";

export interface IGameSprite<T extends GameSchema> {
    instance: T
    bindToInstance()
}

export class GameSpriteGroup<M extends GameSchema, MS extends GameObject & IGameSprite<any>> extends Group {
    private _spriteDict: Map<string, MS> = new Map<string, MS>()
    readonly instanceModel: { new(): M }
    readonly spriteModel: { new(scene: KitchenScene, instance: M): MS };

    constructor(scene, instanceModel: (new (...args) => M), spriteModel: (new (scene: KitchenScene, instance: M) => MS)) {
        super(scene);
        this.instanceModel = instanceModel
        this.spriteModel = spriteModel
    }

    findOrCreate(instance): MS {
        return this.find(instance) || this.createSceneSpriteOf(instance)
    }

    createSceneSpriteOf(instance): MS {
        let t = this.createSprite(instance)
        this.add(t)
        return t
    }

    private createSprite(instance: M) {
        return new this.spriteModel(this.scene as KitchenScene, instance);
    }

    add(child: MS): any {
        this._spriteDict.set(this.keyFor(child), child)
        return super.add(child);
    }

    remove(child: MS, removeFromScene?: boolean, destroyChild?: boolean): this {
        this._spriteDict.delete(this.keyFor(child))
        return super.remove(child, removeFromScene, destroyChild);
    }

    find = (instance: M): MS => this.findById(this.idOf(instance));

    findById = (id: string): MS => this._spriteDict.get(id)

    getDict = (): ReadonlyMap<string, MS> => this._spriteDict

    private idOf(instance: M) {
        return instance?.id;
    }

    private keyFor(child: MS) {
        let ingredient = child.instance;
        return this.idOf(ingredient);
    }


}
